document.addEventListener("DOMContentLoaded",(function(){const t=document.getElementById("ruffruff-table-of-contents");if(t&&t.parentNode){const e=t.parentNode;e.insertBefore(t,e.firstChild),t.style.marginBottom="20px"}}));
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const blogLinks = document.querySelectorAll('a.gm-target[title="Blog"]');
    blogLinks.forEach(link => {
      link.setAttribute('href', '/blogs/blog');
    });
  }, 1000);
});